export type StudioTabId = "bundles" | "exercises" | "templates" | "videos" | "self-care";

type TabDef = { id: StudioTabId; label: string; path: string };

const ALL_TABS: TabDef[] = [
  { id: "bundles", label: "Bundles", path: "/studio/bundles" },
  { id: "exercises", label: "Exercises", path: "/studio/exercises" },
  { id: "templates", label: "Templates", path: "/studio/templates" },
  { id: "videos", label: "Videos", path: "/studio/videos" },
];

const EMPLOYEE_TABS: TabDef[] = [{ id: "bundles", label: "Bundles", path: "/studio/bundles" }];

/** Clinical decision trees — superadmin only (RLS on self_care_trees matches). */
const SUPERADMIN_TABS: TabDef[] = [{ id: "self-care", label: "Self Care", path: "/studio/self-care" }];

export function getStudioSidebarTabs(isEmployee: boolean, isSuperadmin = false): TabDef[] {
  if (isEmployee) return EMPLOYEE_TABS;
  return isSuperadmin ? [...ALL_TABS, ...SUPERADMIN_TABS] : ALL_TABS;
}

/** Active when this section route (or bundle player) matches. */
export function isStudioNavPathActive(pathname: string, tabPath: string): boolean {
  if (pathname === tabPath || pathname.startsWith(`${tabPath}/`)) return true;
  if (tabPath === "/studio/bundles" && pathname.startsWith("/studio/player/")) return true;
  return false;
}
